module.exports = __webpack_public_path__ + "static/img/irq.54b4fac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/irq.png
// module id = 170
// module chunks = 4